import React from 'react';
import { Field, useFormikContext } from 'formik';
import { FormattedMessage } from 'react-intl';
import { DropdownComponent } from '../../../../../components/prime-formik';
import { buildWorkAreaOptions } from '../../helpers/super-profiles.helper';

const SuperProfileWorkAreaInput = () => {
  const {
    setFieldValue,
    values: { occupationalLevel, workCategory },
  } = useFormikContext();

  const workAreaOptions = buildWorkAreaOptions(occupationalLevel, workCategory);

  return (
    <div className="p-col-12">
      <div className="flex-space-between">
        <FormattedMessage id="account.super-profiles.new.work-area" defaultMessage="Work area">
          {(text) => (
            <label className="field-label" htmlFor="workArea">
              {text}
            </label>
          )}
        </FormattedMessage>
        <FormattedMessage id="select" defaultMessage="Select">
          {(text) => (
            <Field
              id="workArea"
              name="workArea"
              component={DropdownComponent}
              options={workAreaOptions}
              filter
              filterBy="label,value"
              className="right"
              onChange={(event) => {
                setFieldValue('workArea', event.value);
              }}
              placeholder={`-- ${text} --`}
            />
          )}
        </FormattedMessage>
      </div>
    </div>
  );
};

export default SuperProfileWorkAreaInput;
